import bem from 'utils/bem';

export const block = bem('back-catalog-upsell-modal');
